var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-card"},[(_vm.representative || _vm.industry)?_c('dashboard-representative',{attrs:{"name":_vm.nameUser}}):_c('dashboard-logistic-operator',{attrs:{"name":_vm.nameUser}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }